var map = {
	"./aparthotelclub/ic_tag_duration.png": 21891,
	"./beachful/ic_tag_duration.png": 95517,
	"./castlepedia/ic_tag_duration.png": 56852,
	"./cocktayl/ic_tag_duration.png": 56339,
	"./ic_tag_duration.png": 70959,
	"./luxresortclub/ic_tag_duration.png": 79166,
	"./parkful/ic_tag_duration.png": 33057,
	"./prefabworld/ic_tag_duration.png": 54895,
	"./rooftopclub/ic_tag_duration.png": 12220,
	"./spaclub/ic_tag_duration.png": 51428,
	"./worldcasino/ic_tag_duration.png": 71151,
	"./zoopedia/ic_tag_duration.png": 93304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57781;